import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=5182c95a&scoped=true"
import script from "./Location.vue?vue&type=script&lang=js"
export * from "./Location.vue?vue&type=script&lang=js"
import style0 from "./Location.vue?vue&type=style&index=0&id=5182c95a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5182c95a",
  null
  
)

export default component.exports